"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.switchImages = switchImages;
exports.switchCase = switchCase;
exports.capture = capture;
exports.SwitchWitch = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _fromEvent = require("rxjs/observable/fromEvent");

var _operators = require("rxjs/operators");

function $$(selector) {
  return Array.prototype.slice.call(document.querySelectorAll(selector));
}

function cartesianProduct(callback, a, b) {
  return a.reduce(function (acc, v1) {
    return acc.concat(b.map(function (v2) {
      return callback(v1, v2);
    }));
  }, []);
}

var SwitchWitch =
/*#__PURE__*/
function () {
  function SwitchWitch(breakpoint) {
    (0, _classCallCheck2.default)(this, SwitchWitch);
    Object.defineProperty(this, "_breakpoint", {
      configurable: true,
      enumerable: true,
      writable: true,
      value: void 0
    });
    this._breakpoint = breakpoint;
  }

  (0, _createClass2.default)(SwitchWitch, [{
    key: "isMobile",
    value: function isMobile() {
      return window.innerWidth < this._breakpoint;
    }
  }, {
    key: "onLayoutChange",
    value: function onLayoutChange(callback) {
      var _this = this;

      (0, _fromEvent.fromEvent)(window, 'resize').pipe((0, _operators.scan)(function (acc) {
        return [acc[1], _this.isMobile()];
      }, [this.isMobile(), this.isMobile()]), (0, _operators.filter)(function (acc) {
        return acc[0] ? !acc[1] : acc[1];
      })).subscribe(function (acc) {
        return callback(acc[1]);
      });
    }
  }]);
  return SwitchWitch;
}();

exports.SwitchWitch = SwitchWitch;

function switchImages(isMobile) {
  ['_pc', '_sp'].map(function (suffix) {
    return "img[src*='".concat(suffix, "']");
  }).concat(['[style^="background-image:"]']).filter(function (selector) {
    return $$(selector).length !== 0;
  }).map(function (selector) {
    var isImgTag = /^img/.test(selector);
    return $$(selector).map(function (element) {
      var src = isImgTag ? element.getAttribute('src') || '' : element.getAttribute('style') || '';
      var currentSuffix = isMobile ? '_sp' : '_pc';
      var replacement = src.replace(/(_pc|_sp)\.(.+)$/, "".concat(currentSuffix, ".$2"));
      return element.setAttribute(isImgTag ? 'src' : 'style', replacement);
    });
  });
}

function switchCase(cases, expression) {
  var filtered = cases.filter(function (_ref) {
    var _ref2 = (0, _slicedToArray2.default)(_ref, 1),
        comparator = _ref2[0];

    return comparator(expression);
  });
  return filtered.length ? filtered[0][1] : false;
}

function capture(x) {
  var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (x) {
    return x;
  };
  console.log(x);
  callback(x);
  return x;
}